import {
  FETCH_ITINERARY_BEGIN,
  FETCH_ITINERARY_SUCCESS,
  FETCH_ITINERARY_FAILURE
} from '../actions/fetchItinerary'

const initialState = {
  isLoading: false,
  hasErrors: false,
  itineraries: {}
}

export default function itineraryData(state = initialState, action) {
  switch (action.type) {
    case FETCH_ITINERARY_BEGIN:
      return {
        ...state,
        isLoading: true,
        hasErrors: false
      }
    case FETCH_ITINERARY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasErrors: false,
        itineraries: {
          ...state.itineraries,
          [action.payload.identifier]: action.payload.itinerary
        }
      }
    case FETCH_ITINERARY_FAILURE:
      return {
        ...state,
        isLoading: false,
        hasErrors: true
      }
    default:
      return state
  }
}
